var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"no-wrapper":"","elevated":"","label":_vm.label,"color":_vm.activeColor(_vm.name),"text-color":_vm.activeTextColor(_vm.name)},on:{"click":function($event){return _vm.$emit('input', _vm.name)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }